import { render } from "./SecondNav.vue?vue&type=template&id=1ab267e3&scoped=true"
import script from "./SecondNav.vue?vue&type=script&lang=js"
export * from "./SecondNav.vue?vue&type=script&lang=js"

import "./SecondNav.vue?vue&type=style&index=0&id=1ab267e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab267e3"]])

export default __exports__